import {Template, Component, Attribute} from '@scoutgg/ftw/source/lib'
import {Match, Team, Lineup} from '../../models'
import template from './team-picker.jade'
import {sortPlayers} from '../../services/positions'

const statuses = {
  confirmed: [
    'confirmed',
    'bench',
    'refuted',
  ],
  expected: [
    'expected',
    'possible',
    'unexpected',
    'suspended',
    'injured',
  ],
}

const statusWords = {
  confirmed: 'Lineup',
  bench: 'Bench',
  refuted: 'N/A',
  expected: 'Expected',
  possible: 'Possible',
  unexpected: 'Unexpected',
  suspended: 'Suspended',
  injured: 'Injured',
}

@Component('sporty')
@Template(template)
@Attribute('match', Match)
@Attribute('team', Team)
@Attribute('batch', Number)
@Attribute('context', String)
@Attribute('priced-only', Boolean)
export default class TeamPicker extends HTMLElement {
  created() {
    this.lineups = []
  }

  attached() {
    this.update(this.match.load())
      .then(() => this.update(this.team.load({season: this.match.seasonId})))
  }

  matchChange() {
    this.update(this.match.load())
  }

  teamChange() {
    this.update(this.team.load({season: this.match.seasonId}))
  }

  select(player, status) {
    if(player === 'all') {
      for(const player of this.sortedPlayers) {
        this.select(player, status)
      }
      return
    }
    if(status === 'refuted') return this.unselect(player)
    var lineup = this.getLineup(player)
    if(lineup) {
      lineup.status = status
    } else {
      lineup = this.addLineup(player, status)
    }
    this.emit('select:lineup', {lineup})
  }

  unselect(player) {
    var lineup = this.getLineup(player)
    if(!lineup) return
    this.emit('unselect:lineup', {lineup})
  }

  playerClass(lineup) {
    var status = lineup ? lineup.status : 'refuted'
    if(~this.statuses.indexOf(status)) return status
  }

  isChecked(player, status) {
    var lineup = this.getLineup(player)
    if(lineup && lineup.status === status) return true
    if(!lineup &&  ['refuted', 'unexpected'].includes(status)) return true
    return false
  }

  getLineup(player) {
    const { lineups, batch } = this
    return (lineups || [])
      .filter(l => l.player === player)
      .find(l => !batch || l.batch === batch)
  }

  addLineup(player, status) {
    var lineup = Lineup.create({
      player: player,
      team: this.team,
      match: this.match,
      batch: this.batch,
      status: status,
    })
    return lineup
  }

  get sortedPlayers() {
    const prices = this.playerPrices
    const sport = this.match && this.match.sport
    const exclusions = []
    const excluded = exclusions.includes(sport)
    const tags = (this.match.tag || '').split(/\s+/).filter(a => a)
    return (this.players || [])
      .filter(p => {
        const priceObj = prices[p]
        if(!priceObj) return false
        if(priceObj.disabled) return false
        if(!this.pricedOnly) return true
        if(priceObj.seasonPrice) return true
        const matchPrice = priceObj.prices[this.match]
        return matchPrice && +matchPrice.price
      })
      .filter(p => {
        if(!excluded) return true
        if(!tags.length) return true
        if(p.position === 'manager') return true
        return tags.find(t => t === p.position)
      })
      .sort(sortPlayers)
  }

  get playerPrices() {
    return (this.prices || []).reduce((obj, p) => {
      obj[p.player] = p
      return obj
    }, {})
  }

  get statuses() {
    return statuses[this.context || 'confirmed']
  }

  get statusWords() {
    return statusWords
  }

  get refuted() {
    return this.sortedPlayers
      .filter(p => {
        var lineup = this.getLineup(p)
        return !lineup || !~['confirmed', 'bench'].indexOf(lineup.status)
      })
      .map(p => Lineup.create({
        player: p,
        team: this.team,
        match: this.match,
        status: 'refuted',
      }))
  }
}
